export { EvidencePage } from './EvidencePage.tsx';
export { OverviewPage } from './OverviewPage.tsx';
export { FindingsPage } from './FindingsPage.tsx';
import { Link } from '@tanstack/react-router';

export { EngagementsPage } from './EngagementsPage.tsx';

export function NotFoundPage() {
  return (
    <section aria-labelledby="page-title" style={{ display: 'grid', gap: 'var(--space-4)' }}>
      <h1 id="page-title">This page does not exist</h1>
      <p>
        <Link to="/">Return to the overview</Link>
      </p>
    </section>
  );
}
